import React from 'react'
import project from '../../project'
// import Data from './Data'
// import BreachCodes from './BreachCodes'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import { Tracking219 } from './Tracking'
// import VisibilitySensor from 'react-visibility-sensor'
// import { ajaxSetup } from 'jquery'
import axios from 'axios';

import "../assets/styles/home.scss"

// Players Data
const apiURL_storage_data = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/AFLultimatePlayerRatings2025/prod/AFLultimatePlayerRatings2025.json'

// ajaxSetup({ cache: true })

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.scrollDiv = React.createRef()
    this.state = {
      firstInteraction: false,
      appInViewport: false,
      data: undefined,
      breach: null,
      SubscriptionUrl: '',
      siteDomain: '',
      siteCode: '',
      activeCard: null,
      isMobApp: false,
      preselect: null,
    }

    // this.siteCode = this.siteCode.bind(this)
    // this.checkBreach = this.checkBreach.bind(this)
    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('click', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })

    this.state.preselect = appContainer.getAttribute('data-club')
    
  }

  componentDidMount () {
    // this.checkBreach()
    this.loadData()
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  /*siteCode (siteHostname) {
    let siteCode, siteDomain
    switch (siteHostname) {
      
      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break
      
      case 'www.codesports.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesportsuat.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break
      
      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        siteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break

      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break
      
      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }*/

  /*goLogin () {
    const loginButton = document.querySelectorAll('.header_log-in, .tgc-auth-buttons_login') // Mastheads, Regionals
    loginButton[0].click()
  }*/

  /*
  checkBreach () {

    const isDeskMobAttribute = document.body.getAttribute('data-device')
    // console.log('isDeskMobAttribute', isDeskMobAttribute)
    const isMobileApp = ( isDeskMobAttribute === 'mobile' || isDeskMobAttribute === 'desktop' ) ? false : true
    // console.log('isMobileApp', isMobileApp)

    if (isMobileApp) {
      this.state.breach = false
      this.state.isMobApp = true
      this.loadData()

    } else if (window.utag_data) {
      if( (typeof window.utag_data.net_platform !== "undefined") && (typeof window.utag_data.pc_memtype !== "undefined") ) {
          const currentDomain = window.location.hostname
          const currentUrl = window.location.href
          const netsite = this.siteCode(window.location.hostname)
          const netplatform = window.utag_data.net_platform
          const breachSourceCode = BreachCodes[netsite][netplatform]
          const subUrl = 'https://'
            + currentDomain
            + '/subscribe/news/1/'
            + '?sourceCode=' + breachSourceCode
            + '&dest=' + encodeURIComponent(currentUrl)
            + '&memtype=anonymous&mode=premium'
            + '&v21=dynamic-hot-control-score&V21spcbehaviour=append'

          this.state.SubscriptionUrl = subUrl
          this.state.breach = ( utag_data && utag_data.pc_memtype == "subscriber" ) ? false : true;
          this.loadData()

      }
      else {
          setTimeout(this.checkBreach, 250);
      }
    }
    else {
      setTimeout(this.checkBreach, 250);
    }
    
  }*/

  /*dataSlash () {
    let slashedData = []
    const items = this.state.data

    // console.log('items', items)

    items.forEach(function(item){
      if ( item[0] <= 2 ) {
        slashedData.push(item)
      } else {
        // item[0] = ''
        // item[1] = ''
        // item[2] = ''
        item[3] = ''
        item[4] = ''
        slashedData.push(item)
      }
      
    })

    // console.log('slashedData', slashedData)

    this.setState({
      data: slashedData
    })

  }*/

  scroll2message () {
    this.scrollDiv.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /*goSubscribe () {
    window.location.assign(this.state.SubscriptionUrl);
  }*/

  /*loadData () {
    
    this.setState({
      data: Data
    }, function () {
      if ( this.state.breach === true ) {
        this.dataSlash()
      }
    });
    
  }*/

  loadData () {
    
    axios.get(apiURL_storage_data)
    .then((response) => {
      // console.log('response', response)
      let titlesRemoved = response.data.values
      titlesRemoved.shift()

      let clubData = [
        {'team' : 'Adelaide Crows', 'players' : []},
        {'team' : 'Brisbane Lions', 'players' : []},
        {'team' : 'Carlton', 'players' : []},
        {'team' : 'Collingwood', 'players' : []},
        {'team' : 'Essendon', 'players' : []},
        {'team' : 'Fremantle', 'players' : []},
        {'team' : 'Geelong Cats', 'players' : []},
        {'team' : 'Gold Coast Suns', 'players' : []},
        {'team' : 'GWS Giants', 'players' : []},
        {'team' : 'Hawthorn', 'players' : []},
        {'team' : 'Melbourne', 'players' : []},
        {'team' : 'North Melbourne', 'players' : []},
        {'team' : 'Port Adelaide', 'players' : []},
        {'team' : 'Richmond', 'players' : []},
        {'team' : 'St Kilda', 'players' : []},
        {'team' : 'Sydney Swans', 'players' : []},
        {'team' : 'West Coast Eagles', 'players' : []},
        {'team' : 'Western Bulldogs', 'players' : []},
      ]

      // console.log('clubData', clubData)

      const cleanData = titlesRemoved.filter( card => card.length )

      // console.log('cleanData', cleanData)

      cleanData.forEach((player) => {
        const club = player[2]
        // console.log('club', club)
        const matchingClub = clubData.filter(aClub => {
          return aClub.team == club
        })
        // console.log('matchingClub', matchingClub)
        // console.log('matchingClub', matchingClub[0].players)
        matchingClub[0].players.push(player)

      });

      if (this.state.preselect) {
        clubData = clubData.filter(obj => obj.team === this.state.preselect);
      }

      this.setState({
        // data: dataPaired
        data: clubData
      }, () => {
        this.checkSolo()
      })

    })
    .catch((err) => {
      console.log('err', err)
    })

    // this.loadResults()


  }

  checkSolo () {
    if (this.state.preselect) {
      const card = document.querySelector('.nnd-row');
      if (card) {
        setTimeout(() => {
          card.click()
        }, 1000);
      }
    }
  }

  expandCard (e, id) {
    
    /*if ( ( this.state.breach === true ) && ( id > 2 ) )  {
      this.closeCard()
      return
    }*/

    // console.log('id', id)
    
    const targetRow = e.target.closest('.nnd-row')
    const targetSection = targetRow.querySelector('.nnd-col-text-content')
    const targetSectionHeight = targetSection.offsetHeight
    const targetImage = targetRow.querySelector('.nnd-col-img')
    const targetImageHeight = targetImage.offsetHeight
    const existActiveRow = document.querySelector(".nnd-row.nnd-active")

    if ( targetRow === this.state.activeCard ) {
      targetRow.classList.toggle(`nnd-active`)
      
      this.setState({
        activeCard: null
      }, function () {
        targetRow.style.height = targetImageHeight + 'px'
      });

    } else {
      
      if (existActiveRow) {
        const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-col-img').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        existActiveRow.style.height = existActiveRowImageHeight + 'px'
      }

      this.setState({
        activeCard: targetRow
      }, function () {
        const currentCard =  this.state.activeCard
        currentCard.classList.toggle(`nnd-active`)
        currentCard.style.height = targetImageHeight + 'px'
        targetRow.style.height = ( targetSectionHeight + targetImageHeight )+ 'px'
      });

    }
  }

  closeCard () {
    const existActiveRow = document.querySelector(".nnd-row.nnd-active")
    if (existActiveRow) {
      
      this.setState({
        activeCard: null
      }, function () {
        const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-col-img').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        existActiveRow.style.height = existActiveRowImageHeight + 'px'
        this.scroll2message()
      });

    } else {
      this.scroll2message()
    }
    
  }

  render() {
    const cards = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      // console.log('item', item)
      const club = item.team.replaceAll(' ', '-')
      if (typeof this.state.data !== 'undefined') {
        return (
         <div key={club} className={`nnd-row nnd-expert-${club}`} onClick={(e) => { this.expandCard(e, item.team); e.preventDefault() }}>
           <div className="nnd-col-img">
             <picture>
               <source srcSet={require(`../assets/images/${club}.jpg`)} media="(min-width: 768px)" />
               <img loading="lazy" srcSet={require(`../assets/images/${club}.jpg`)} src={require(`../assets/images/${club}.jpg`)} />
             </picture>
             <div className="nnd-cta">
              <h4 className="nnd-cta-name">{ item.team }</h4>
              <div className="nnd-cta-icon" data-index={item.team}>
                <div className="nnd-cta-icon_plus"></div>
                <div className="nnd-cta-icon_plus_vertical"></div>
              </div>
            </div>
           </div>
           <section className="nnd-col-text">
             <div className="nnd-col-text-content">
                <div className="nnd-col-text-inner">
                  <div className="nnd-players">
                    {item.players.map((player) => (
                      <div key={player[0]} className="nnd-player-row">
                        <div className="nnd-player-name"> {player[1]}</div>
                        <div className="nnd-player-grade"><span>{player[3]}</span></div>
                        <div className="nnd-player-bio">{player[4]}</div>
                      </div>
                    ))}
                  </div>
                </div>
             </div>
           </section>

         </div>
        )
      }
    }) : ''

    const isBreached = this.state.breach
    const isActiveCard = this.state.activeCard
    const isMobApp = this.state.isMobApp
    const isPreselect = this.state.preselect

    return (
      <div className={isBreached === true ? 'nnd-container nnd-breach' : 'nnd-container nnd-premium'} data-mobapp={isMobApp} data-preselect={isPreselect ? 'true' : 'false'}>
        <div className="nnd-header">
          <img alt="The Ultimate Player Ratings" src={require('../assets/images/header.jpg')} />
          {/*<h2>Ultimate AFL player ratings</h2>*/}
          <p>Footy experts Jon Ralph and Glenn McFarlane rate every player in the AFL 2025</p>
        </div>
        <div name="nnd-expert" className={isActiveCard !== null ? 'nnd-cont-main nnd-activeCard' : 'nnd-cont-main'}>
          {cards}
        </div>

        {/*isBreached === true
          ? 
          <div id="nnd-breach-overlay" className="nnd-breach-overlay" ref={this.scrollDiv}>
            <VisibilitySensor onChange={this.visChange} delayedCall='true'>
              {this.state.siteDomain !== 'codesports'
                ?
                <div className="nnd-breach-message-metro">
                  <p className="nnd-bm1"><span>There's more to this story.</span></p>
                  <p className="nnd-bm1"><span>Subscribe to unlock all the players</span></p>
                  <p className="nnd-bm2">$1 a week for the first 12 weeks.<br />(min cost $4)</p>
                  <a className="nnd-breachLink" onClick={(e) => { this.goSubscribe(e) }}>Subscribe</a>
                  <p className="nnd-bm3"><a onClick={(e) => { this.goLogin(e); e.preventDefault() }}>Log in</a> | T&Cs apply</p>
                </div>
                :
                <div className="nnd-breach-message-cs">
                  <p className="nnd-bm1">Read the full story.</p>
                  <p className="nnd-bm2">$1 for the first 2 months*</p>
                  <a className="nnd-breachLink" onClick={(e) => { this.goSubscribe(e) }}>Try Now</a>
                  <p className="nnd-bm4">Already a subscriber? <a onClick={(e) => { this.goLogin(e); e.preventDefault() }}>Sign in</a> |  <a href="https://www.codesports.com.au/more-information/terms-and-conditions">*T&Cs apply</a></p>
                </div>
              }
            </VisibilitySensor>
          </div>
          : ''
            */}

      </div>
    )
  }
}

// {isBreached === false ? <div>BREACHED FALSE</div> : <div>BREACHED TRUE</div>} 
// <img className="nnd-logo" src={require(`../assets/images/logos/${this.state.siteDomain}-white.svg`)} />

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js